import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';
import { AlertBlock } from '@/cms/definitions/content-types';
import { isDateSpanValid } from '@/views/calculators/services/ValidationService';

@Options({
	name: 'MessageComponent',
	components: {},
	props: {
		alertBlock: Object as PropType<AlertBlock>,
	},
})
export default class MessageComponent extends Vue {
	public alertBlock!: AlertBlock;
	public static showMessageAll = true;
	public showMessage = false;

	public created() {
		if (this.hasActiveMessage()) {
			setTimeout(
				() => {
					this.showMessage = MessageComponent.showMessageAll;
				},
				this.alertBlock.displayDelayInMillis ? parseInt(this.alertBlock.displayDelayInMillis) : 2500
			);
		} else {
			MessageComponent.showMessageAll = false;
			this.showMessage = false;
		}
	}

	public mounted(): void {
		addEventListener('click', this.closeMessage);
		addEventListener('keyup', this.closeMessage);
	}
	public beforeUnmount() {
		this.removeListeners();
	}

	private removeListeners() {
		removeEventListener('click', this.closeMessage);
		removeEventListener('keyup', this.closeMessage);
	}
	public closeMessage() {
		this.removeListeners();
		MessageComponent.showMessageAll = false;
		this.showMessage = false;
	}

	private hasActiveMessage() {
		if (this.alertBlock?.alertText) {
			return isDateSpanValid(this.alertBlock.validFrom, this.alertBlock.validTo);
		}
		return false;
	}
}
